import type { BriefingSessionAdmin } from '@/api/lcMarketing'
import { SESSION_MODE_LABELS } from './inquiryLabels'

export interface BriefingSessionOption {
  value: string
  label: string
  modeLabel: string
  searchText: string
  attendanceLabel: string
}

/** Administrator history is independent of the public application window. */
export function buildBriefingSessionOptions(sessions: BriefingSessionAdmin[]): BriefingSessionOption[] {
  return [...sessions]
    .sort((a, b) => Date.parse(b.startsAt) - Date.parse(a.startsAt))
    .map((session) => {
      const label = new Intl.DateTimeFormat('ko-KR', {
        timeZone: 'Asia/Seoul', year: 'numeric', month: 'numeric', day: 'numeric',
        weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false,
      }).format(new Date(session.startsAt))
      const modeLabel = SESSION_MODE_LABELS[session.mode]
      const attendanceLabel = `신청 ${session.activeApplicationCount} · 참석 ${session.attendedCount ?? 0} · 미기록 ${session.unknownAttendanceCount ?? 0}`
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit',
      }).formatToParts(new Date(session.startsAt))
      const year = parts.find((part) => part.type === 'year')?.value
      const month = parts.find((part) => part.type === 'month')?.value
      const day = parts.find((part) => part.type === 'day')?.value
      return {
        value: session.sessionId,
        label,
        modeLabel,
        attendanceLabel,
        searchText: `${year}-${month}-${day} ${Number(month)}/${Number(day)} ${label} ${modeLabel}`.toLocaleLowerCase('ko-KR'),
      }
    })
}

export function filterBriefingSessionOptions(options: BriefingSessionOption[], query: string) {
  const search = query.trim().toLocaleLowerCase('ko-KR')
  return search ? options.filter((option) => option.searchText.includes(search)) : options
}
